const formFieldTextWithCopy = {
    success: 'Skopiowano do schowka',
    copy: 'Skopiuj',
    open: 'Otwórz',
};

export default formFieldTextWithCopy;